import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import {
    TextField,
    Button,
    Typography,
    Stack,
    Box,
    CircularProgress
} from "@mui/material";

const ForgotPasswordPage = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        if (loading || sent) return;

        if (!email.trim()) {
            setError("メールアドレスを入力してください");
            return;
        }

        setLoading(true);
        setError("");
        setMessage("");

        try {
            await axiosInstance.post("/user/request", {
                email: email.trim()
            });

            // セキュリティ上、存在しなくても成功扱い
            setMessage("再設定用のメールを送信しました。");
            setSent(true);

        } catch (e) {
            setError("送信に失敗しました");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack minHeight="100vh" justifyContent="center" alignItems="center">
            <Box sx={{ width: "100%", maxWidth: 400, p: 2, textAlign: "center" }}>

                <Typography variant="h5" mb={2}>
                    パスワード再設定
                </Typography>

                <Typography fontSize={14} mb={2}>
                    登録しているメールアドレスを入力してください
                </Typography>

                <TextField
                    fullWidth
                    label="メールアドレス"
                    type="email"
                    value={email}
                    disabled={sent}
                    onChange={(e) => setEmail(e.target.value)}
                />

                {error && (
                    <Typography color="error" mt={1}>
                        {error}
                    </Typography>
                )}

                {message && (
                    <Typography color="primary" mt={1}>
                        {message}
                    </Typography>
                )}

                <Stack spacing={2} mt={3}>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleSubmit}
                        disabled={loading || sent}
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : sent ? "送信済み" : "送信"}
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => navigate("/login")}
                    >
                        ログインに戻る
                    </Button>

                </Stack>

            </Box>
        </Stack>
    );
};

export default ForgotPasswordPage;
